<template>
  <svg
    class="unidentified-object-caution-icon"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      class="auto-cognition-frame"
      cx="14"
      cy="14"
      r="11.5"
      stroke="#EFF335"
      stroke-opacity="0.6"
    />
    <circle cx="14" cy="14" r="4" fill="#EFF335" fill-opacity="0.8" />
  </svg>
</template>

<script>
export default {
  name: "UnidentifiedObjectCautionIcon",
};
</script>
